import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import NewsCard from '../components/NewsCard';

export default function NewsList() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchNews() {
      try {
        const res = await fetch('/_api/public/content/nyheder');
        if (res.ok) {
          const data = await res.json();
          const items = Array.isArray(data) ? data : data?.items || [];
          const published = items.filter((item) => item.publiceret !== false);
          published.sort((a, b) => new Date(b.dato || 0) - new Date(a.dato || 0));
          setNews(published);
        }
      } catch (err) {
        console.warn('Error loading news:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchNews();
  }, []);

  return (
    <>
      <SEO
        title="Nyheder - Fastlane ApS"
        description="Følg med i seneste nyheder, logistikprojekter og opdateringer fra Fastlane ApS."
        canonicalUrl="https://fastlane.dk/nyheder"
      />

      <PageHeader
        title="Nyheder"
        subtitle="Seneste nyt om transporter, spedition, lagerfaciliteter og logistikløsninger."
        breadcrumbs={[{ label: 'Nyheder' }]}
      />

      <div className="py-12 sm:py-16 bg-white min-h-[50vh]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="py-16 text-center text-slate-500 text-sm">
              <i className="fa-solid fa-spinner fa-spin text-xl text-sky-600 mb-2 block" aria-hidden="true" />
              Henter nyheder fra CMS...
            </div>
          ) : news.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {news.map((item) => (
                <NewsCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <div className="max-w-md mx-auto text-center py-16 px-4 bg-slate-50 rounded-2xl border border-slate-200">
              <i className="fa-regular fa-newspaper text-3xl text-slate-400 mb-3" aria-hidden="true" />
              <h3 className="text-lg font-bold text-slate-800">Ingen nyheder endnu</h3>
              <p className="text-sm text-slate-500 mt-1">
                Der er på nuværende tidspunkt ingen publicerede nyheder. Opret nyheder i CMS-panelet.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
